import styled from "styled-components";

const CardBadgesContent = styled.div`
    display: flex;
    >span{ 
        color: var(--grey-softer);
        font-size: 12px;
        font-weight:bold;
        padding: 3px 6px;
        border-radius: 2px;
        margin: 0 0.25rem 0.25rem 0;
        &.default-color-font{
            background-color: var(--grey-dark);
        }
        &.purple{
            background-color: var(--purple);
        }
        &.blue{
            background-color: var(--blue);
        }
        &.green{
            background-color: var(--green);
        }
        &.red{
            background-color: var(--red);
        }
        &.orange{
            background-color: var(--orange);
        }
    }
`;

export default CardBadgesContent;
